module.exports = __webpack_public_path__ + "static/media/try-01.f33d1200.svg";